import React, { useState } from "react";
import { Plus } from "lucide-react";
import { Reveal, SectionHeading } from "./Atoms";

const FAQS = [
  {
    q: "What is RFMG Connect?",
    a: "RFMG Connect is the official digital hub of Revival Fire Ministries Global. It's where you can request prayer, join ministry updates, give, listen to recordings, learn about Fire Hubs, and connect with the Prophetic Mentorship Group.",
  },
  {
    q: "What is Revival Fire Ministries Global?",
    a: "A prophetic and apostolic holiness revival movement commissioned to draw the hearts of men back to God by preaching the unadulterated Word of God with power and demonstration of the Spirit of God.",
  },
  {
    q: "How can I request prayer?",
    a: "Use the Request Prayer section on this page. Your request is kept private and handled with care by ministry leadership.",
  },
  {
    q: "How can I join ministry updates?",
    a: "Fill out the Join RFMG Updates form. You'll receive announcements, prayer gatherings, teachings, service recordings, fasting calls, Fire Hub updates, and revival event information.",
  },
  {
    q: "What are Fire Hubs?",
    a: "Fire Hubs and Revival Hubs are altars of consecration, prayer, training, deliverance, discipleship, evangelism, and apostolic mobilization being raised up across America and the nations.",
  },
  {
    q: "How can I listen to service recordings?",
    a: "Visit the Service Recordings section to access recent teachings, prayer calls, and revival services.",
  },
  {
    q: "How can I give or partner?",
    a: "We offer giving through Cash App ($RevivalFireGlobal), PayPal (Revivalfireteam@gmail.com), Zelle (RevivalFireteam@gmail.com), card, and bank transfer. All giving is processed through trusted third-party platforms.",
  },
  {
    q: "How can I join the Prophetic Mentorship Group?",
    a: "Use the Telegram link in the Prophetic Mentorship section. The group is for those seeking covering, training, equipping, and revival alignment.",
  },
  {
    q: "How can I attend future tent revivals or crusades?",
    a: "Join RFMG Updates to receive announcements about upcoming tent revivals, crusades, prayer gatherings, and revival events across the nation.",
  },
  {
    q: "How can I contact the ministry?",
    a: "Use the Contact section below, or email rfmgcontact@gmail.com.",
  },
];

const FAQItem = ({ q, a, open, onClick, idx }) => (
  <div className="border-b border-[#C9A44C]/15">
    <button
      onClick={onClick}
      className="w-full py-6 flex items-start justify-between text-left gap-6 group"
      aria-expanded={open}
      data-testid={`faq-q-${idx}`}
    >
      <span className="font-serif-display text-xl sm:text-2xl text-[#F6F0E6] leading-snug">
        {q}
      </span>
      <span
        className={`mt-1 h-9 w-9 rounded-full border border-[#C9A44C]/35 flex items-center justify-center flex-shrink-0 transition-transform duration-500 ${
          open ? "rotate-45" : ""
        }`}
      >
        <Plus className="h-4 w-4 text-[#C9A44C]" strokeWidth={1.5} />
      </span>
    </button>
    <div
      className={`grid transition-[grid-template-rows] duration-500 ease-out ${
        open ? "grid-rows-[1fr] pb-6" : "grid-rows-[0fr]"
      }`}
    >
      <div className="overflow-hidden">
        <p className="text-[#D9D9D9] text-[15px] leading-relaxed max-w-3xl">{a}</p>
      </div>
    </div>
  </div>
);

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <section id="faq" className="relative py-28 px-6 section-ember">
      <div className="max-w-5xl mx-auto">
        <Reveal>
          <SectionHeading
            overline="Frequently Asked"
            title={<>Answers from the <span className="italic gold-text">altar</span></>}
          />
        </Reveal>
        <div>
          {FAQS.map((f, i) => (
            <Reveal key={f.q} delay={i * 30}>
              <FAQItem
                idx={i}
                q={f.q}
                a={f.a}
                open={openIdx === i}
                onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
